module.exports = __webpack_public_path__ + "img/1518297140.b0309aa3.jpg";